import type { UserSettingsUpdate } from '@/services/user-v2-service/types'
import { useUserStore } from '@/stores/userStore'
import { debounce } from 'lodash'
import { onMounted, ref, watch } from 'vue'
import { useAuthStore } from '@/stores/authStore'

type KeyToChange =
  | 'enable_alerts_sf'
  | 'enable_alerts_dc'
  | 'enable_alerts_dc_spot'
  | 'enable_alerts_ff'
  | 'enable_alerts_ss'
  | 'enable_alerts_fs'

export function useTelegramSignals(keyToChange: KeyToChange) {
  const userStore = useUserStore()
  const tgSignals = ref(false)
  const authStore = useAuthStore()
  let isInitializing = true

  onMounted(() => {
    tgSignals.value = authStore.settings[keyToChange]
      ? authStore.settings[keyToChange] == '1'
      : false
    isInitializing = false
  })

  const toggle = debounce(async (value: boolean) => {
    const data = {
      amount_usdt: null,
      amount_usdt_futures: null,
      amount_usdt_spot_futures: null,
      amount_usdt_futures_spot: null,
      enable_alerts_sf: null,
      enable_alerts_dc: null,
      enable_alerts_dc_spot: null,
      enable_alerts_ff: null,
      enable_alerts_ss: null,
      enable_alerts_fs: null,
    } as UserSettingsUpdate
    data[keyToChange] = value
    await userStore.saveUserSettings(data)
  }, 500)

  watch(tgSignals, (v) => {
    if (isInitializing) return
    toggle(v)
  })

  return { tgSignals }
}
